/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, DEFAULT_SLOT, GroupContext, Provider, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { Drawer, DrawerContext, type DrawerProps } from '../drawer/drawer.component';
import { IconButtonContext } from '../icon-button/icon-button.component';
import { IconContext } from '../icon/icon.component';
import { ListBoxContext } from '../list-box/list-box.component';
import { SearchFieldContext } from '../search-field/search-field.component';
import { HorizontalNavigationContext } from '../horizontal-navigation/horizontal-navigation.component';

type NavigationSideProps = DrawerProps;

const NavigationSideContext = createContext<ContextValue<NavigationSideProps, HTMLDivElement>>({});

const NavigationSide = forwardRef((props: NavigationSideProps, ref: ForwardedRef<HTMLDivElement>) => {
  const [navigationContext] = useContextProps(
    { isOpen: props.isOpen, onOpenChange: props.onOpenChange },
    null,
    HorizontalNavigationContext,
  );

  [props, ref] = useContextProps(props, ref, NavigationSideContext);

  const { style, children, ...coreProps } = props;

  return (
    <Provider
      values={[
        [
          DrawerContext,
          {
            placement: 'left',
            style: [styles.base, style],
            ref,
            ...coreProps,
            isOpen: navigationContext.isOpen,
            onOpenChange: navigationContext.onOpenChange,
          },
        ],
        [
          GroupContext,
          {
            slots: {
              [NAVIGATION_SIDE_SLOTS.LOGO_GROUP]: {
                role: 'presentation',
                ...stylex.props(groupVariants.logo),
              },
              [NAVIGATION_SIDE_SLOTS.AVATAR_GROUP]: {
                role: 'presentation',
                ...stylex.props(groupVariants.avatar),
              },
            },
          },
        ],
        [
          ListBoxContext,
          {
            selectionMode: 'single',
            selectionBehavior: 'replace',
            disallowEmptySelection: true,
            'aria-label': 'Main navigation',
            onSelectionChange: () => navigationContext.onOpenChange?.(false),
            style: listBoxStyles.base,
          },
        ],
        [
          SearchFieldContext,
          {
            size: 36,
            isRounded: true,
          },
        ],
        [
          IconButtonContext,
          {
            variant: 'ghost',
            size: 32,
          },
        ],
        [
          IconContext,
          {
            slots: {
              [DEFAULT_SLOT]: {},
              [NAVIGATION_SIDE_SLOTS.LOGO]: {
                style: logoStyles.base,
              },
            },
          },
        ],
      ]}
    >
      <Drawer>{children}</Drawer>
    </Provider>
  );
});

const styles = stylex.create({
  base: {
    gap: 24,
    paddingBlock: 16,
    width: 294,
    paddingInline: 8,
    boxSizing: 'border-box',
    borderRightColor: $.border04,
    borderRightStyle: 'solid',
    borderRightWidth: 1,
  },
});

const groupVariants = stylex.create({
  logo: {
    gap: 4,
    paddingBlock: 4,
    paddingInline: 12,
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    justifyContent: 'space-between',
  },
  avatar: {
    gap: 12,
    paddingInline: 8,
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
  },
});

const listBoxStyles = stylex.create({
  base: { height: '100%' },
});

const logoStyles = stylex.create({
  base: { marginRight: 'auto' },
});

const NAVIGATION_SIDE_SLOTS = {
  LOGO: 'logo',
  LOGO_GROUP: 'logo-group',
  AVATAR_GROUP: 'avatar-group',
};

export { NAVIGATION_SIDE_SLOTS, NavigationSide, NavigationSideContext, type NavigationSideProps };
